var React = require('react');

function IcError1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.5 0C7.8 0 0 7.9 0 17.5S7.8 35 17.5 35 35 27.2 35 17.5 27.2 0 17.5 0zm2 27.6h-4v-3.5h4v3.5zm0-6.9h-4V7.4h4v13.3z"}));
}

IcError1.defaultProps = {"viewBox":"0 0 35 35"};

module.exports = IcError1;

IcError1.default = IcError1;
